export default __webpack_public_path__ + "static/media/KNX Leaflet cs6 low_compressed (2).50613c27.pdf";